import React from 'react';
import { ChannelListTemplate } from 'themes/modules/channel/pages';
import { ChannelListViewStore } from 'modules/channel/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ChannelListViewStore(rootStore), 'channelListViewStore')
class ChannelList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<ChannelListTemplate
				{...this.props}
				change={this.props.channelListViewStore.change}
				actions={this.props.channelListViewStore}
				showFiller={true}
				viewStore={this.props.channelListViewStore}
			/>
		);
	}
}

export default ChannelList;
